let syncInProgress = false;
let currentSyncInfo = null;

export const acquireSyncLock = async (syncInfo = {}) => {
  return new Promise(resolve => {
    if (!syncInProgress) {
      syncInProgress = true;
      currentSyncInfo = syncInfo;
      resolve(true);
    } else {
      // Reject instead of queuing
      resolve(false);
    }
  });
};

export const releaseSyncLock = () => {
  syncInProgress = false;
  currentSyncInfo = null;
};

export const isSyncInProgress = () => syncInProgress;

export const getCurrentSyncInfo = () => currentSyncInfo;

export const waitForSyncToComplete = (
  maxWaitTime = 30000,
  checkInterval = 500,
) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkSync = setInterval(() => {
      if (!syncInProgress) {
        clearInterval(checkSync);
        resolve(true);
      } else if (Date.now() - startTime > maxWaitTime) {
        clearInterval(checkSync);
        reject(new Error('Sync wait timeout'));
      }
    }, checkInterval);
  });
};
